var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTakyonShortLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 16,
    viewBox: "0 0 36 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_53_2238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.21697 0.0098877H0V2.25244H6.21697V0.0098877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.353 6.05305C19.6616 4.88838 18.2985 4.20825 16.6051 4.20825C13.3024 4.20825 10.9952 6.58815 10.9952 9.99537C10.9952 13.4026 13.3637 16 16.6269 16C18.2493 16 19.5292 15.3825 20.353 14.2102V15.6726H22.5398V4.53458H20.353V6.05195V6.05305ZM16.6915 13.7597C14.7891 13.7597 13.1821 12.0753 13.1821 10.0822C13.1821 7.96378 14.6578 6.42663 16.6915 6.42663C18.7252 6.42663 20.2665 8.10112 20.2665 10.0822C20.2665 12.0632 18.63 13.7597 16.6915 13.7597Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1222 4.53454L27.1019 9.28334V0.00769043H24.915V15.6737H27.1019V11.1545L31.4963 15.6737H34.555L29.2263 10.0986L33.7958 4.53454H31.1222Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7902 2.25024V0.0065918H11.1114C8.72106 0.0065918 6.776 1.96017 6.776 4.36204V15.6847H9.00877V4.36204C9.00877 3.19736 9.95176 2.25024 11.1114 2.25024H15.7902Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 0H33.7639V2.24585H36V0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_53_2238"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakyonShortLight);
export default __webpack_public_path__ + "static/media/TakyonShortLight.9bff004aa4cd02b09cfcd1fca88eae1f.svg";
export { ForwardRef as ReactComponent };